


import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { Conflict, Fix, ExtendedSelection, Selection, HouseConfiguration } from '../../utils/api/api';
import ResponsiveImage from '../utils/ResponsiveImage/index.vue';
import { namespace } from 'vuex-class';
import generateITSMedia from '@/utils/helpers/generateITSMedia';

const configurationModule = namespace('configuration');

@Component({
  components: {
    ResponsiveImage
  }
})
export default class ConflictPrompt extends Vue {
  @Prop({ default: () => [] }) conflicts!: Conflict[];

  @configurationModule.Action updateConfiguration!: (payload: { update: Selection[] }) => Promise<HouseConfiguration>;

  private selectedVariant = 0;

  private transformToMediaContainer(url: string) {
    return generateITSMedia(url, {
      MQ1: [284, 284],
      MQ2: [284, 284],
      MQ3: [284, 284],
      MQ4: [284, 284],
      MQ5: [424, 424],
      MQ6: [256, 256]
    });
  }

  get conflict(): Conflict {
    return this.conflicts[0];
  }

  get causes(): ExtendedSelection[] {
    return this.conflict.causes;
  }

  get variants(): Fix[] {
    return this.conflict.fixes;
  }

  get hasVariants(): boolean {
    return this.variants.length > 1;
  }

  private filterSteps(steps: ExtendedSelection[]) {
    return steps.filter(step => step.selection.isSelected);
  }

  private selectVariant(variantIndex: number) {
    this.selectedVariant = variantIndex;
  }

  private async resolveConflicts() {
    await this.updateConfiguration({
      update: this.variants[this.selectedVariant].steps.map(step => step.selection)
    });

    this.closeModal();
  }

  @Emit()
  private closeModal() {
    return;
  }
}
